module.exports = __webpack_public_path__ + "img/agaves.d02be354.jpg";